module.exports = __webpack_public_path__ + "static/media/dashboardActiveIcon.05a78721.svg";